import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { ApiService } from 'src/app/services/api.service';
import { UeberkategorieFilter } from 'src/app/data/user/ueberkategorie-filter.model';
import { Indikator } from 'src/app/data/indikator.model';
import { indikatorenAuswahlDaten } from 'src/app/immutable/indikatoren-auswahl-daten';
import { IndikatorTyp } from 'src/app/immutable/enums/indikator-typ';
import { UserIndikatorenUeberkategorieFilter } from 'src/app/data/user/user-indikatoren-ueberkategorie-filter.model';
import { UserBegleitIndikator } from 'src/app/data/user/user-begleit-indikator.model';
import { Router } from '@angular/router';
import { Synopse } from 'src/app/data/ws/synopse.model';
import { MatTabGroup } from '@angular/material/tabs';
import { ErgebnisDataService } from 'src/app/services/ergebnis-data.service';
import { ErgebnisStorage } from 'src/app/data/ergebnis-storage.model';
import { ConstantsStorage } from 'src/app/immutable/constants-storage';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { faArrowRight, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import {
  GlobalConstantsRouting,
  SessionStorageService,
} from 'globales-projekt-angular';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  anwendungsname = ConstantsTexte.ANWENDUNGSNAME;

  faInfoCircle = faInfoCircle;
  faArrowRight = faArrowRight;

  ueberkategorieFilter: UeberkategorieFilter[];
  sumFilter: number = 0;
  sumFilterBegleitindikatoren: number = 0;

  indikatorenGeoffnet: boolean = true;
  adbGeoffnet: boolean = true;
  ueberkategorienGeoffnet: boolean = true;

  indikatoren: Indikator[];

  showWaitingForDataSpinner: boolean = false;

  constructor(
    private apiService: ApiService, 
    private ergebnisDataService: ErgebnisDataService,
    private router: Router
  ) {}

  ngAfterViewInit() {
    if (this.ergebnisDataService.ergebnisStorage != null) {
      if (this.ergebnisDataService.ergebnisStorage.isBegleitIndikator)
        this.tabGroup.selectedIndex = 1;

      this.ergebnisDataService.ergebnisStorage = null;
    }
  }

  ngOnInit() {
    if (this.ergebnisDataService.ergebnisStorage != null) {
      this.indikatoren = this.ergebnisDataService.ergebnisStorage.indikatoren;

      this.ueberkategorieFilter =
        this.ergebnisDataService.ergebnisStorage.ueberkategorieFilter;

      this.sumFilter = this.ergebnisDataService.ergebnisStorage.sumFilter;
      this.sumFilterBegleitindikatoren =
        this.ergebnisDataService.ergebnisStorage.sumFilterBegleitindikatoren;
    } else {
      this.apiService.getIndikatorRichtungen().subscribe((response) => {
        this.indikatoren = response as Indikator[];

        for (let entry of this.indikatoren) {
          if (entry.subIndikatoren != null) {
            let tmp: Indikator[] = entry.subIndikatoren;

            for (let entry2 of tmp) {
              entry2.checked = false;
              entry2.indeterminate = false;
            }
          }

          entry.checked = false;
          entry.indeterminate = false;
          entry.indikatorTyp = IndikatorTyp.TIER;
        }

        this.indikatoren = this.indikatoren.concat(indikatorenAuswahlDaten);
      });
      this.loadFilterAnzahl(new UserIndikatorenUeberkategorieFilter());

      this.loadFilterAnzahlBegleitindikatoren(new UserBegleitIndikator());
    }
  }

  loadFilterAnzahl(userIndikatoren: UserIndikatorenUeberkategorieFilter) {
    this.showWaitingForDataSpinner = true;

    this.apiService
      .postUeberkategorieFilterAnzahl(userIndikatoren)
      .subscribe((response) => {
        let oldUeberkategorieFilterSelected: UeberkategorieFilter[] =
          this.ueberkategorieFilter;

        let links: UeberkategorieFilter[] = [];
        let rechts: UeberkategorieFilter[] = [];
        let linksRechts: UeberkategorieFilter[] = [];

        if (response.length % 2 == 0) {
          links = response.slice(0, response.length / 2);
          rechts = response.slice(response.length / 2);
        } else {
          links = response.slice(0, Math.ceil(response.length / 2));
          rechts = response.slice(Math.floor(response.length / 2) + 1);
        }

        let i: number = 0;

        for (let entry of links) {
          linksRechts.push(entry);
          if (i != rechts.length) linksRechts.push(rechts[i]);

          i++;
        }

        this.ueberkategorieFilter = linksRechts;

        for (let entry of this.ueberkategorieFilter) {
          entry.checked = false;
        }

        if (oldUeberkategorieFilterSelected != null) {
          for (let entry of oldUeberkategorieFilterSelected) {
            this.setCheckFilter(entry.idUeberkategorie, entry.checked);
          }
        }

        this.showWaitingForDataSpinner = false;
      });

    this.showWaitingForDataSpinner = true;

    this.apiService
      .postIndikatorenAnzahl(userIndikatoren)
      .subscribe((response) => {
        this.sumFilter = response;
        this.showWaitingForDataSpinner = false;
      });
  }

  loadFilterAnzahlBegleitindikatoren(
    userBegleitIndikator: UserBegleitIndikator
  ) {
    this.showWaitingForDataSpinner = true;

    this.apiService
      .postBegleitIndikatorErgebnisseListe(userBegleitIndikator)
      .subscribe((response) => {
        let ergebnis: Synopse[] = response;

        this.sumFilterBegleitindikatoren = ergebnis.length;

        this.showWaitingForDataSpinner = false;
      });
  }

  setAll(
    checked: boolean,
    idIndikator: Number,
    istBegleitindikatoren: Boolean
  ) {
    for (let entry of this.indikatoren) {
      if (entry.idIndikator == idIndikator) {
        if (entry.subIndikatoren != null) {
          let tmp: Indikator[] = entry.subIndikatoren;

          for (let entry2 of tmp) {
            this.setCheck(
              checked,
              idIndikator,
              entry2.idIndikator,
              istBegleitindikatoren,
              false
            );
          }
        } else {
          entry.checked = checked;
        }
      }
    }

    if (!istBegleitindikatoren)
      this.loadFilterAnzahl(this.createUserIndikatorenUeberkategorieFilter());
    if (istBegleitindikatoren)
      this.loadFilterAnzahlBegleitindikatoren(
        this.createUserBegleitIndikator()
      );
  }

  setCheck(
    checked: boolean,
    idIndikator: Number,
    idSubIndikator: Number,
    istBegleitindikatoren: Boolean,
    loadData: Boolean
  ) {
    let count = 0;

    for (let entry of this.indikatoren) {
      if (entry.idIndikator == idIndikator) {
        let tmp: Indikator[] = entry.subIndikatoren;

        for (let entry2 of tmp) {
          if (entry2.idIndikator == idSubIndikator) {
            entry2.checked = checked;
            entry2.indeterminate = checked;
          }

          if (entry2.checked) count++;
        }

        entry.checked = count == entry.subIndikatoren.length;
        entry.indeterminate =
          count != entry.subIndikatoren.length && count != 0;
      }
    }

    if (loadData) {
      if (!istBegleitindikatoren)
        this.loadFilterAnzahl(this.createUserIndikatorenUeberkategorieFilter());
      if (istBegleitindikatoren)
        this.loadFilterAnzahlBegleitindikatoren(
          this.createUserBegleitIndikator()
        );
    }
  }

  setCheckFilter(idUeberkategorie: Number, checked: boolean) {
    for (let entry of this.ueberkategorieFilter) {
      if (entry.idUeberkategorie == idUeberkategorie) entry.checked = checked;
    }
  }

  createUserBegleitIndikator(): UserBegleitIndikator {
    let userBegleitIndikator: UserBegleitIndikator = new UserBegleitIndikator();

    for (let entry of this.indikatoren) {
      if (!entry.checked && !entry.indeterminate) continue;

      switch (
        +entry.indikatorTyp // das Forum sagt, dass das + Notwendig ist um daraus eine Zahl zu machen, sonst funktioniert das nicht sauber.
      ) {
        case IndikatorTyp.BEGLEIT_INDIKATOR:
          if (userBegleitIndikator.indikatoren == null)
            userBegleitIndikator.indikatoren = [];
          for (let entry2 of entry.subIndikatoren)
            if (entry2.checked)
              userBegleitIndikator.indikatoren.push(entry2.indikator);
          break;
      }
    }

    return userBegleitIndikator;
  }

  createUserIndikatorenUeberkategorieFilter(): UserIndikatorenUeberkategorieFilter {
    let userIndikatorenUeberkategorieFilter: UserIndikatorenUeberkategorieFilter =
      new UserIndikatorenUeberkategorieFilter();

    for (let entry of this.indikatoren) {
      if (!entry.checked && !entry.indeterminate) continue;

      switch (
        +entry.indikatorTyp // das Forum sagt, dass das + Notwendig ist um daraus eine Zahl zu machen, sonst funktioniert das nicht sauber.
      ) {
        case IndikatorTyp.INDIKATORENART:
          if (userIndikatorenUeberkategorieFilter.indikatorart == null)
            userIndikatorenUeberkategorieFilter.indikatorart = [];
          for (let entry2 of entry.subIndikatoren)
            if (entry2.checked)
              userIndikatorenUeberkategorieFilter.indikatorart.push(
                entry2.indikator
              );
          break;
        case IndikatorTyp.DIMENSION_DES_TIERWOHLS:
          if (userIndikatorenUeberkategorieFilter.dimensionDesTierwohls == null)
            userIndikatorenUeberkategorieFilter.dimensionDesTierwohls = [];
          for (let entry2 of entry.subIndikatoren)
            if (entry2.checked)
              userIndikatorenUeberkategorieFilter.dimensionDesTierwohls.push(
                entry2.indikator
              );
          break;
        case IndikatorTyp.LEBENSABSCHNITT:
          if (userIndikatorenUeberkategorieFilter.lebensabschnitt == null)
            userIndikatorenUeberkategorieFilter.lebensabschnitt = [];
          for (let entry2 of entry.subIndikatoren)
            if (entry2.checked)
              userIndikatorenUeberkategorieFilter.lebensabschnitt.push(
                entry2.indikator
              );
          break;
        case IndikatorTyp.TIER:
          if (userIndikatorenUeberkategorieFilter.idIndikatorRichtungen == null)
            userIndikatorenUeberkategorieFilter.idIndikatorRichtungen = [];

          if (
            entry.subIndikatoren != null &&
            entry.subIndikatoren.length != 0
          ) {
            for (let entry2 of entry.subIndikatoren)
              if (entry2.checked)
                userIndikatorenUeberkategorieFilter.idIndikatorRichtungen.push(
                  entry2.idIndikator
                );
          } else {
            userIndikatorenUeberkategorieFilter.idIndikatorRichtungen.push(
              entry.idIndikator
            );
          }
      }
    }

    return userIndikatorenUeberkategorieFilter;
  }

  createUserIndikatorenErgebnisse(): UserIndikatorenUeberkategorieFilter {
    let userIndikatorenUeberkategorieFilter: UserIndikatorenUeberkategorieFilter =
      this.createUserIndikatorenUeberkategorieFilter();

    userIndikatorenUeberkategorieFilter.idsUeberkategorienFilter = [];

    for (let entry of this.ueberkategorieFilter) {
      if (!entry.checked) continue;

      userIndikatorenUeberkategorieFilter.idsUeberkategorienFilter.push(
        entry.idUeberkategorie
      );
    }

    if (
      userIndikatorenUeberkategorieFilter.idsUeberkategorienFilter.length == 0
    )
      userIndikatorenUeberkategorieFilter.idsUeberkategorienFilter = null;

    return userIndikatorenUeberkategorieFilter;
  }

  sendTierwohlIndikatoren() {
    this.showWaitingForDataSpinner = true;
    SessionStorageService.clear();

    let userIndikatorenUeberkategorieFilter: UserIndikatorenUeberkategorieFilter =
      this.createUserIndikatorenErgebnisse();

    this.apiService
      .postIndikatorenErgebnisseListe(userIndikatorenUeberkategorieFilter)
      .subscribe((response) => {
        SessionStorageService.setItem(
          ConstantsStorage.USER_INDIKATOREN_UEBERKATEGORIE_FILTER,
          userIndikatorenUeberkategorieFilter
        );

        let ergebnisStorage: ErgebnisStorage = new ErgebnisStorage();
        ergebnisStorage.indikatoren = this.indikatoren;
        ergebnisStorage.ueberkategorieFilter = this.ueberkategorieFilter;
        ergebnisStorage.isBegleitIndikator = false;
        ergebnisStorage.sumFilter = this.sumFilter;
        ergebnisStorage.sumFilterBegleitindikatoren =
          this.sumFilterBegleitindikatoren;

          SessionStorageService.setItem(
          ConstantsStorage.ERGEBNIS_STORAGE,
          ergebnisStorage
        );

        ergebnisStorage.synopsen = response;
        this.ergebnisDataService.setErgebnisStorage(ergebnisStorage);

        this.router.navigate([GlobalConstantsRouting.ERGEBNISSE]);
      });
  }

  sendBegleitIndikator() {
    this.showWaitingForDataSpinner = true;
    SessionStorageService.clear();

    let userBegleitIndikator: UserBegleitIndikator =
      this.createUserBegleitIndikator();

    this.apiService
      .postBegleitIndikatorErgebnisseListe(userBegleitIndikator)
      .subscribe((response) => {
        SessionStorageService.setItem(
          ConstantsStorage.USER_BEGLEIT_INDIKATOR,
          userBegleitIndikator
        );

        let ergebnisStorage: ErgebnisStorage = new ErgebnisStorage();
        ergebnisStorage.indikatoren = this.indikatoren;
        ergebnisStorage.ueberkategorieFilter = this.ueberkategorieFilter;
        ergebnisStorage.isBegleitIndikator = true;
        ergebnisStorage.sumFilter = this.sumFilter;
        ergebnisStorage.sumFilterBegleitindikatoren =
          this.sumFilterBegleitindikatoren;

        SessionStorageService.setItem(
          ConstantsStorage.ERGEBNIS_STORAGE,
          ergebnisStorage
        );

        ergebnisStorage.synopsen = response;
        this.ergebnisDataService.setErgebnisStorage(ergebnisStorage);

        this.router.navigate([GlobalConstantsRouting.ERGEBNISSE]);
      });
  }

  setUeberkategorienOpened() {
    this.ueberkategorienGeoffnet = true;
  }

  setUeberkategorienClosed() {
    this.ueberkategorienGeoffnet = false;
  }

  setADBOpened() {
    this.adbGeoffnet = true;
  }

  setADBClosed() {
    this.adbGeoffnet = false;
  }

  setIndikatorenOpened() {
    this.indikatorenGeoffnet = true;
  }

  setIndikatorenClosed() {
    this.indikatorenGeoffnet = false;
  }
}
